import { InjectionToken } from '@angular/core';
import { MenuItemInterface } from '../types';

export const PAGE_ROUTES_INJECTION = new InjectionToken<{
  [key: string]: string;
}>('PAGE_ROUTES');

export const MENU_ITEMS_INJECTION = new InjectionToken<MenuItemInterface[]>(
  'MENU_ITEMS',
);

export const uiKitScope = 'uiKit';
